export interface Config {
  server_url: string;
  app_url: string;
  client_id: string;
}

const configProd: Config = {
  server_url: "https://mdl-app.mynext.id",
  app_url: "https://mdl-app.mynext.id/api/v1/test_app",
  client_id: "https://mdl-app.mynext.id",
};

const configLocal: Config = {
  server_url: "http://localhost:8005",
  app_url: "http://localhost:8005/api/v1/test_app",
  client_id: "https://mdl-app.mynext.id",
};

const cfg: any = {
  "https://mdl-app.mynext.id": configProd,
  "http://localhost:8005": configLocal,
}
const url = window.location.origin;

export default (cfg[url]);
